import {
	type ACTAnalyticsEvent,
	type ACTInteractedUIEvent,
	type ACTScreenUIEvent,
} from '../../types';

export function isInteractedUIEvent(event: ACTAnalyticsEvent): event is ACTInteractedUIEvent {
	return (event as ACTInteractedUIEvent).payload.action !== undefined;
}

export function isScreenUIEvent(event: ACTAnalyticsEvent): event is ACTScreenUIEvent {
	return (event as ACTScreenUIEvent).payload.name !== undefined;
}
